
export const notFound = {
  title: "Hups! Seite nicht gefunden",
  description: "Die Seite, die Sie suchen, existiert nicht oder wurde verschoben. Keine Sorge, das passiert den Besten von uns!",
  suggestions: {
    title: "Das können Sie versuchen:",
    checkUrl: "Prüfen Sie, ob die URL korrekt geschrieben ist",
    tryAgain: "Aktualisieren Sie die Seite oder versuchen Sie es später erneut",
    contactUs: "Kontaktieren Sie unser Support-Team, wenn Sie Hilfe benötigen"
  },
  actions: {
    goToHome: "Zur Startseite",
    goToDashboard: "Zum Dashboard",
    goBack: "Zurück"
  },
  helpText: "Benötigen Sie Hilfe? Unser Support-Team ist da, um Ihnen zu helfen, wieder auf Kurs zu kommen."
};
